import * as React from 'react'
import { isLightTheme, setDarkTheme, setLightTheme } from '@/lib/theme'
import { Button } from './Button'

export function ThemeToggle() {
  const [light, setLight] = React.useState<boolean>(isLightTheme())
  const toggle = () => {
    if (light) {
      setDarkTheme()
      setLight(false)
    } else {
      setLightTheme()
      setLight(true)
    }
  }
  return (
    <Button variant="outline" onClick={toggle}>
      {light ? 'Light' : 'Dark'}
    </Button>
  )
}

